import { render, staticRenderFns } from "./proGeneric.vue?vue&type=template&id=56072ae0&"
import script from "./proGeneric.vue?vue&type=script&lang=js&"
export * from "./proGeneric.vue?vue&type=script&lang=js&"
import style0 from "./proGeneric.vue?vue&type=style&index=0&id=56072ae0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports